var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNordicTrackset(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 44 44",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#nordic-trackset_svg__clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.4 12.175c1.6 0 2.8-1.3 2.8-2.8 0-1.6-1.3-2.8-2.8-2.8-1.5 0-2.8 1.3-2.8 2.8 0 1.5 1.3 2.8 2.8 2.8zM7.7 28.575c0 3.3 3 6 6.6 6h15.4c3.6 0 6.6-2.7 6.6-6s-3-6.1-6.6-6.1h-4.6l-1.5 2.5c-.2.4-.6.6-1 .6s-.8-.2-1-.6l-1.6-2.5h-5.7c-3.6 0-6.6 2.7-6.6 6.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6 19.175c-5.6 0-10.2 4.2-10.2 9.4s4.6 9.3 10.2 9.3h14.9c5.6 0 10.2-4.2 10.2-9.3 0-5.2-4.6-9.4-10.2-9.4H27l-.8 1.4h3.2c4.8 0 8.6 3.6 8.6 8s-3.9 8-8.6 8H14.6c-4.8 0-8.6-3.6-8.6-8s3.9-8 8.6-8h4.2l-.8-1.4h-3.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.7 14.375H30l-1.5 2.5h.7c6.6 0 12 5.3 12 11.7 0 6.5-5.4 11.7-12 11.7H14.8c-6.6 0-12-5.3-12-11.7 0-6.5 5.4-11.7 12-11.7h1.7l-1.6-2.5h-1.7c-7.3 0-13.2 5.8-13.2 12.9v2.5c0 7.2 5.9 12.9 13.3 12.9h17.4c7.3 0 13.3-5.8 13.3-12.9v-2.5c0-7.1-5.9-12.9-13.3-12.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8 15.475l.9 1.4 1.5 2.4.9 1.4 2.4 3.9c.1.1.1.1.2.1 0 0 .1 0 .2-.1l2.3-3.8.8-1.4 2.4-3.9.6-.9.5-.9c.7-1.2 1.1-2.7 1.1-4.1 0-4.4-3.6-8-8-8s-8 3.6-8 8c0 1.5.4 2.9 1.2 4.2l1 1.7zm.9-6.1c0-2.6 2.1-4.8 4.8-4.8 2.7 0 4.8 2.1 4.8 4.8 0 2.6-2.1 4.8-4.8 4.8-2.7 0-4.8-2.2-4.8-4.8z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "nordic-trackset_svg__clip0"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(0 1.375)",
    d: "M0 0h44v41H0z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNordicTrackset);
var MemoForwardRef = /*#__PURE__*/React.memo(ForwardRef);
export default __webpack_public_path__ + "a971feb611095fb83ac5acf3dfb8de53.svg";
export { MemoForwardRef as ReactComponent };